/**
 * Decompose a hex colour into the `r, g, b` triple an `rgba(var(--x), a)`
 * declaration needs (item #17764).
 *
 * The attached bar's focus ring is `rgba(var(--primary-color-rgb, ...), 0.25)`
 * because a translucent ring cannot be built from a colour token in colour
 * position -- the same class of constraint decision #5088 records for the
 * submit fill. The triple therefore has to be emitted alongside the colour.
 *
 * Returns null for anything that is not a 3- or 6-digit hex value, so the
 * emitter can leave the property unset and let the declaration's fallback
 * decide, rather than emit a triple that breaks the rgba().
 */
export function hexToRgbTriple(hex) {
  if (typeof hex !== 'string') return null;
  const m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!m) return null;
  let digits = m[1];
  if (digits.length === 3) digits = [...digits].map((d) => d + d).join('');
  const r = parseInt(digits.slice(0, 2), 16);
  const g = parseInt(digits.slice(2, 4), 16);
  const b = parseInt(digits.slice(4, 6), 16);
  return `${r}, ${g}, ${b}`;
}
